import { V1CorporatesLocationsIndex200CorporateLocationsItem } from '~/api/_openapi/schemas';
import { ApiChallenge } from '~/api/v1/challenges/get-type';
import { ApiCompetitionShow } from '~/api/v1/organizations/[id]/competitions/get';
import { ApiOrganizationShow } from '~/api/v1/organizations/[id]/get';
import { ApiV2PresentationSimple } from '~/api/v2/organizations/[id]/presentations/get';
import { PostT } from '~/state/post';
import { isNotEmpty } from '~/utils/array';

import { TabPanelActivity } from './activity';
import { TabPanelHome } from './home';
import { TabPanelPresentation } from './presentation';
import { TabPanelProject } from './project';

type Props = {
  uid: string;
  org: ApiOrganizationShow;
  competitions?: ApiCompetitionShow[];
  isLoadingOrgCompetitions?: boolean;
  orgLocations?: V1CorporatesLocationsIndex200CorporateLocationsItem[];
  isLoadingOrgLocations?: boolean;
  presentations?: ApiV2PresentationSimple[];
  isLoadingOrgPresentations: boolean;
  isLoadingPosts: boolean;
  featuredPosts?: PostT[];
  posts?: PostT[];
  initializeObserver?: (el: HTMLElement | null) => void;
  challenges?: ApiChallenge[];
};

export function SposUidTabList({
  uid,
  org,
  competitions,
  isLoadingOrgCompetitions,
  orgLocations,
  presentations,
  isLoadingOrgPresentations,
  isLoadingPosts,
  featuredPosts,
  posts,
  initializeObserver,
  challenges,
}: Props) {
  const TabList = [
    {
      label: 'ホーム',
      panel: (
        <TabPanelHome
          org={org}
          competitions={competitions}
          isLoadingOrgCompetitions={isLoadingOrgCompetitions}
          orgLocations={orgLocations}
        />
      ),
    },
    // {
    //   label: '活動報告',
    //   panel: (<TabPanelActivity />)
    // },
  ];

  if (isNotEmpty(posts)) {
    TabList.push({
      label: '活動報告',
      panel: (
        <TabPanelActivity
          featuredPosts={featuredPosts}
          initializeObserver={initializeObserver}
          isLoadingPosts={isLoadingPosts}
          posts={posts}
          uid={uid}
        />
      ),
    });
  }

  if (isNotEmpty(presentations)) {
    TabList.push({
      label: 'プレゼンテーション',
      panel: (
        <TabPanelPresentation
          uid={uid}
          organizationName={org.name}
          organizationLogo={org.logo}
          presentations={presentations}
          isLoadingOrgPresentations={isLoadingOrgPresentations}
        />
      ),
    });
  }

  console.log(challenges);
  if (isNotEmpty(competitions) || isNotEmpty(challenges)) {
    TabList.push({
      label: 'プロジェクト',
      panel: <TabPanelProject competitions={competitions} challenges={challenges} />,
    });
  }

  return TabList;
}
